import { IconButton, IconButtonProps } from '@material-ui/core';

import { RiPencilFill as Edit } from '@remixicon/react';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore EditButton and delete. */
export const EditButtonMui = (props: IconButtonProps) => {
  return (
    <IconButton
      size={props.size}
      aria-label="Edit"
      data-track-id="button.edit"
      data-track-action="open-dialog"
      data-track-source-anchor="ced3069f97;;low" {...props}
    >
      <Edit size={props.size === 'small' ? 20 : 24} />
    </IconButton>
  );
};
